import { Navigate } from 'react-router';

import { AdminLayoutComponent } from '@/components/admin/AdminLayoutComponent';
import { useAuthStore } from '@/store/auth.store';

/** Admin manages existing businesses; setting one up for the first time happens in the dashboard app. */
export function RequireBusinessOutlet() {
	const hasBusiness = useAuthStore((state) => state.businesses.length > 0);

	if (!hasBusiness) {
		return <Navigate to="/no-business" replace />;
	}

	return <AdminLayoutComponent />;
}
